import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { MEDIA_TYPE, VideoTrack } from "../../base/media";
import { getScreenTracks, getScreenTracksByParticipantId, getTracksByParticipantId } from "../../base/tracks";
import { isPropertyOpen } from "../functions";
import { layoutType, videoLayoutMode } from "../constants";
import styled from "styled-components";
import ScreenDualFilm from "./ScreenDualFilm";
import UserFilm from "./UserFilm";
import { translate } from "../../base/i18n";

const LayoutContainerStyled = styled.div`
    position: relative;
    
    width: 172px; height: 100%;
    display: flex;
    flex-direction: column;

    .top {
        width: 100%;
        height: 100%;
        display: flex;
        overflow: hidden;
        flex-direction: column;
    }

    & .item {
        width: 100%;
        height: 98px;
        max-height: 98px;

        .videoWrap {position: absolute;}
    }
`;

const ScreenFilmStyled = styled.div`
    flex: 1;
    width: 100%;
    height: 100%;
    justify-content: center;
    display: flex;
    align-items: center;

    .videoWrap {
        overflow: hidden;
        width: 100%;
        position: relative;
        box-sizing: border-box;

        video {
            max-width: 100%;
            max-height: 100%;
        }
    }
`;

function ScreenFilm({ t, type, popupMode, screenShare }) {
    
    return (
        <>
            { type !== layoutType.mobile ? <>
                { popupMode ? 
                    <>
                        <ScreenDualFilm screenShare={screenShare} /> 
                        <div className="center guid"> {t("layout.noCloseScreen")} </div>
                    </>
                    : <>
                        <LayoutContainerStyled>
                            <UserFilm isVertical={true} />
                        </LayoutContainerStyled>
                        <ScreenFilmStyled className="item item_false" id="screenFilm"> 
                            <div className="videoWrap">
                                <VideoTrack videoTrack = { screenShare } />
                            </div>
                        </ScreenFilmStyled>
                    </> }
                </>
                : <div className="item item_false" id="screenFilm" style={{height: '100%', paddingBottom: '0' }}> 
                    <div className="videoWrap">
                        <VideoTrack videoTrack = { screenShare } />
                    </div>
                </div>
            }
        </>
    )
}


function _mapStateToProps(state) {
    const { screenModal } = state['features/video-layout-mode'];
    const { isOpen: isChatOpen } = state['features/chat'];
    const { isOpen: isParticipantOpen } = state["features/participant-right"];
    const { user_id, track_id } = state['features/screen-share'].sharingVideo;

    let videoTrack = null;
    if (track_id) {
        videoTrack = getScreenTracksByParticipantId(state, track_id);
    }
    
    return {
        isChatOpen, isParticipantOpen,
        screenShare: videoTrack,
        popupMode: screenModal
    };
}

export default translate(connect(_mapStateToProps)(ScreenFilm));
